import { useCallback, useState } from 'react';

export const useToggle = (
  initialState = false
): [boolean, () => void, (value: boolean) => void] => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(() => setState(state => !state), []);

  return [state, toggle, setState];
};
